var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.09995 1.7998C7.75906 1.7998 7.44742 1.99241 7.29497 2.29731L6.64372 3.5998H3.59995C3.10289 3.5998 2.69995 4.00275 2.69995 4.4998C2.69995 4.99686 3.1029 5.3998 3.59995 5.3998L3.59995 14.3998C3.59995 15.3939 4.40584 16.1998 5.39995 16.1998H12.6C13.5941 16.1998 14.4 15.3939 14.4 14.3998V5.3998C14.897 5.3998 15.3 4.99686 15.3 4.4998C15.3 4.00275 14.897 3.5998 14.4 3.5998H11.3562L10.7049 2.29731C10.5525 1.99241 10.2408 1.7998 9.89995 1.7998H8.09995ZM6.29995 7.1998C6.29995 6.70275 6.7029 6.2998 7.19995 6.2998C7.69701 6.2998 8.09995 6.70275 8.09995 7.1998V12.5998C8.09995 13.0969 7.69701 13.4998 7.19995 13.4998C6.7029 13.4998 6.29995 13.0969 6.29995 12.5998V7.1998ZM10.8 6.2998C10.3029 6.2998 9.89995 6.70275 9.89995 7.1998V12.5998C9.89995 13.0969 10.3029 13.4998 10.8 13.4998C11.297 13.4998 11.7 13.0969 11.7 12.5998V7.1998C11.7 6.70275 11.297 6.2998 10.8 6.2998Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.b40ff0f2e4bedc0e9515466e5db8d59c.svg";
export { ForwardRef as ReactComponent };